export const isNotNull = (value) => value != null
export const isArray = (value) => isNotNull(value) && Array.isArray(value);
export async function fetchTranslations(source, locale) {
  try {
    return source[locale] || {}; // Return translations for the specified locale, or an empty object if not found
  } catch (error) {
    console.error('Error fetching translations:', error);
    return {}; // Return empty object on error
  }
}

export const isObject = (value) => isNotNull(value)  && !isArray(value) && typeof value === 'object';

// Helper functions for cookies
export const setCookie = (name, value, daysToExpire) => {
  const d = new Date();
  d.setTime(d.getTime() + daysToExpire * 24 * 60 * 60 * 1000);
  document.cookie = [
    `${name}=${encodeURIComponent(value)}`,
    `expires=${d.toUTCString()}`,
    `domain=${process.env.REACT_APP_COOKIE_DOMAIN}`,
    'path=/'
  ].join(';');
};

export const findAndReturnValue = (arr, name) => {
  const selectedObject = arr.find((item) => item.name === name);
  return selectedObject ? selectedObject.value : null;
};

export const numberValue = (value) => {
  const _number = Number(value);
  return isNaN(_number) ? 0 : _number;
};


export const getCookie = (name) => {
  const value = '; ' + document.cookie;
  const parts = value.split('; ' + name + '=');
  if (parts.length === 2) return decodeURIComponent(parts.pop().split(';').shift());
  return null;
};

export const deleteCookie = (name) => {
  document.cookie = [
    `${name}=`,
    'expires=Thu, 01 Jan 1970 00:00:01 GMT',
    `domain=${process.env.REACT_APP_COOKIE_DOMAIN}`,
    'path=/',
    ''
  ].join(';');
};

// Helper functions for JWT to decode it
export const decodeJWT = (token) => {
  const payload = token.split('.')[1];
  const base64Url = payload?.replace(/-/g, '+').replace(/_/g, '/');
  const base64 = base64Url?.padEnd(base64Url?.length + ((4 - (base64Url?.length % 4)) % 4), '=');

  // Decode the base64 string
  const binaryString = window.atob(base64);

  // Convert binary string to a byte array
  const bytes = new Uint8Array(binaryString.length);
  for (let i = 0; i < binaryString.length; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return new TextDecoder('utf-8').decode(bytes);
};

export const formatPrice = (value) => {
  const _number = Number(value);
  if (isNaN(_number)) {
    return `${value}`.replace('.', ',').concat('€');
  }
  return _number.toFixed(2).replace('.', ',').concat('€');
};

export const isZero = (value) => {
  const _number = Number(value);
  return !isNaN(_number) && _number === 0;
};

export const getUrlParamsString = () => {
  const res = [];
  const urlParams = new URLSearchParams(window.location.search);
  for (const key of urlParams.keys()) {
    res.push(`${key}=${urlParams.get(key)}`);
  }
  if (res.length > 0) {
    return `?${res.join('&')}`;
  }
  return '';
};

export const informLanguageChange = () => {
  const key = 'LANG_UPDATED';
  const storage = window.localStorage;
  const old_value = storage.getItem(key);
  const new_value = 'updated';

  storage.setItem(key, new_value);
  window.dispatchEvent(
      new StorageEvent('storage', {
        key: key,
        newValue: new_value,
        oldValue: old_value,
        storageArea: storage,
      })
  );

  if (old_value == null) {
    storage.removeItem(key);
  } else {
    storage.setItem(key, old_value);
  }
  window.dispatchEvent(
      new StorageEvent('storage', {
        key: key,
        newValue: old_value,
        oldValue: new_value,
        storageArea: storage,
      })
  );
};

export const getLangValue = () => {
  return window.sessionStorage.getItem('LANG');
};